import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  create_mentor_portfolio_data_action,
  delete_mentor_portfolio_by_id_data_action,
  update_mentor_portfolio_by_id_data_action,
  get_mentor_all_portfolio_data_action
} from "../../../../redux/_actions";

function usePortfolioInformation(props) {
  const { userPortfolioData } = useSelector(state => state.get_mentor_all_portfolio_data_reducer)

  const [loading, setLoading] = useState(false);
   const [allPortfolio, setAllPortfolio] = useState(null);
   const [addNewPortfolio, SetAddNewPortfolio] = useState(false);
 
   const dispatch = useDispatch()
 
   useEffect(() => {
     callApi();
   }, []);
 
   useEffect(() => {
     if (userPortfolioData?.data) {
       setAllPortfolio(userPortfolioData?.data);
     }
   }, [userPortfolioData, allPortfolio]);
 
   const callApi = async () => {
     setLoading(true)
     const data = await dispatch(get_mentor_all_portfolio_data_action());
 
     setLoading(false)
   }
 
   //on input blur for profile
   const updatePorfolio = async (e, id) => {
 
     let value = e.target.value;
     let key = e.target.name;
     let data = {};
     data[key] = value;
     await dispatch(update_mentor_portfolio_by_id_data_action(data, id));
     callApi();
     return e.target.value === "";
   };
 
 
   // delete portfolio link 
 
   const deletePorfolioLink = async (id) => {
     await dispatch(delete_mentor_portfolio_by_id_data_action(id));
     callApi();
   };
 
   //on input blurr for profile
   const onInputBlur = async (e) => {
     let value = e.target.value;
     let key = e.target.name;
     let data = {};
     data[key] = value;
     await dispatch(create_mentor_portfolio_data_action(data));
     callApi();
     SetAddNewPortfolio(false);
   };
 
   const onAddPortfolioCancleClick = async () => {
    SetAddNewPortfolio(false);
   }

  return {
    loading,
    allPortfolio,
    onInputBlur,
    updatePorfolio,
    deletePorfolioLink,
    SetAddNewPortfolio,
    addNewPortfolio,
    onAddPortfolioCancleClick
  };
}
export default usePortfolioInformation;
